import type { OutreachList } from "../types";
import { OutreachListList } from "./OutreachListList";
import { OutreachListShow } from "./OutreachListShow";

export default {
  list: OutreachListList,
  show: OutreachListShow,
  recordRepresentation: (record: OutreachList) => record?.name,
};
